import $foreign from "./foreign.cjs";
var unsafeHasOwnProperty = $foreign.unsafeHasOwnProperty;
var unsafeHasProperty = $foreign.unsafeHasProperty;
var unsafeReadPropImpl = $foreign.unsafeReadPropImpl;
export { unsafeHasOwnProperty, unsafeHasProperty, unsafeReadPropImpl };
